export default function preloaderGame9(scene) {

	scene.load.image(`background-game12`, `/img/game12/MAISON 4.png`);
	// scene.load.image(`background-game12`, `/img/game12/background-final.png`);
	// scene.load.image(`road-game12`, `/img/game12/road.png`);

	scene.load.audio("maisonSong", ["/audio/songs/12-maison.mp3"]);

	scene.load.spritesheet(`jiu-game12`,
		`/img/game12/jiu.png`,
		{ frameWidth: 25, frameHeight: 37 }
	);

	scene.load.spritesheet(`sua-game12`,
		`/img/game12/sua.png`,
		{ frameWidth: 27, frameHeight: 37 }
	);

	scene.load.spritesheet(`siyeon-game12`,
		`/img/game12/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37 }
	);

	scene.load.spritesheet(`handong-game12`,
		`/img/game12/handong.png`,
		{ frameWidth: 25, frameHeight: 37 }
	);

	scene.load.spritesheet(`yoohyeon-game12`,
		`/img/game12/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37 }
	);

	scene.load.spritesheet(`dami-game12`,
		`/img/game12/dami.png`,
		{ frameWidth: 25, frameHeight: 37 }
	);

	scene.load.spritesheet(`gahyeon-game12`,
		`/img/game12/gahyeon.png`,
		{ frameWidth: 25, frameHeight: 37 }
	);

	scene.load.spritesheet(`enemy1-game12`,
	`/img/game12/enemy-1.png`,
	{ frameWidth: 25, frameHeight: 37}
);

scene.load.spritesheet(`enemy2-game12`,
	`/img/game12/enemy-2.png`,
	{ frameWidth: 25, frameHeight: 37}
);	

scene.load.spritesheet(`bullet-left-game12`,
	`/img/game12/bullet-left.png`,
	{ frameWidth: 30, frameHeight: 20}
);

scene.load.spritesheet(`bullet-right-game12`,
	`/img/game12/bullet-right.png`,
	{ frameWidth: 30, frameHeight: 20}
);

	scene.load.spritesheet(`humo-game12`,
		`/img/generalSprites/humo-big.png`,
		{ frameWidth: 41, frameHeight: 42}
	);

}